import { ISSUED_AMOUNT_KEY } from '@esentai/core/features/giftCertificates/consts/keys';
import { annotations } from '@esentai/core/features/giftCertificates/serializer';
import { ascending } from '@esentai/core/query-dsl';
import { sort } from '@esentai/core/serializers/params';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: ascending(ISSUED_AMOUNT_KEY),
  }),
});
